export default __webpack_public_path__ + "static/brcc-before-image-dc90534ee30381adc62b9c4006e9abda.webp";